/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, computed, inject, Input } from "@angular/core";
import { AuthService } from "src/app/pages/auth";
import { environment } from "src/environments/environment";
import { CoreMenuItem } from "../../../../../menu/core-menu";
import { SYSTEM_NAVIGATION_MENU } from "../../../../../menu/menus.data";

@Component({
  selector: "app-sidebar-menu",
  templateUrl: "./sidebar-menu.component.html",
  styleUrls: ["./sidebar-menu.component.scss"],
  standalone: false,
})
export class SidebarMenuComponent {
  @Input() set toggle(value: boolean) {
    this.isToggle = value;
  }
  @Input() set hover(value: boolean) {
    this.isHover = value;
  }

  isToggle = false;
  isHover = false;

  SYSTEM_NAVIGATION_MENU = SYSTEM_NAVIGATION_MENU;
  visibleNavigationMenu = computed(() =>
    SYSTEM_NAVIGATION_MENU
      .map((menu) => this.filterMenuByRole(menu))
      .filter((menu): menu is CoreMenuItem => menu != null),
  );

  private auth = inject(AuthService);

  private filterMenuByRole(menu: CoreMenuItem): CoreMenuItem | null {
    if (!this.canShowMenu(menu)) {
      return null;
    }

    if (menu.children == null || menu.children.length === 0) {
      return menu;
    }

    const children = menu.children
      .map((child) => this.filterMenuByRole(child))
      .filter((child): child is CoreMenuItem => child != null);

    if (children.length === 0) {
      return null;
    }

    return {
      ...menu,
      children,
    };
  }

  private canShowMenu(menu: CoreMenuItem): boolean {
    if (menu.featureFlag && !environment[menu.featureFlag]) {
      return false;
    }

    if (menu.role == null || menu.role.length === 0) {
      return true;
    }

    const activeRoleId = this.auth.getActiveRoleId();
    const activeRoleNumber = activeRoleId == null ? null : Number(activeRoleId);
    const roleAllowed =
      activeRoleNumber != null && menu.role.some((role) => Number(role) === activeRoleNumber);
    if (!roleAllowed) {
      return false;
    }

    return true;
  }
}
